import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectTenantOpennetworkDomainsListItems } from '../../../../../redux/tenant-open-network-domains/selector';
import { selectNetworksListItems } from '../../../../../redux/dbaas/networks/selector';
import { tenantOpenNetworkDomains } from '../../../../../redux/tenant-open-network-domains/action';
import { selectGatewayRegistriesQueryItems } from '../../../../../redux/gateway-registries/selector';
import { gatewayRegistries } from '../../../../../redux/gateway-registries/action';
import GatewayRegistryComponent from '../components/gateway-registries/gateway-registries.component';
import { selectStoresListItems } from '../../../../../redux/stores/selector';
import { stores } from '../../../../../redux/stores/action';
import storePersist from '../../../../../redux/storePersist';
import { deepCopy } from '../../../../../common/services/common.service';
import { selectGatewaysListItems } from '../../../../../redux/gateways/selector';
import { addNewRow } from '../../../../../common/services/add-new-row';
import { selectChannelListItems } from '../../../../../redux/channel/selector';
import { channel } from '../../../../../redux/channel/action';

let currentChange: any = {}

const GatewayRegistry = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGatewayRegistriesQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const domainItems = useSelector(selectTenantOpennetworkDomainsListItems)
  const NetworkItems = useSelector(selectNetworksListItems)
  const channelsList = useSelector(selectChannelListItems);

  const [isQuery, setIsQuery] = useState<boolean>(false)

  const [domains, setDomains] = useState<{ Domain: string, Network: string, CoreVersion: string, Status: string }[]>([])
  const [whitelistedRoutes, setWhitelistedRoutes] = useState<{ Name: string, Value: string }[]>([])
  const [blacklistedNPs, setBlacklistedNPs] = useState<{ Name: string, Value: string }[]>([])
  const [includedCitiesForCatalog, setIncludedCitiesForCatalog] = useState<{ Name: string, Value: string, State: string }[]>([])
  const [excludedCitiesForCatalog, setExcludedCitiesForCatalog] = useState<{ Name: string, Value: string, State: string }[]>([])
  const [maskedKeywords, setMaskedKeywords] = useState<{ Keyword: string }[]>([])

  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
  const storeLists = useSelector(selectStoresListItems)
  const gatewayItems = useSelector(selectGatewaysListItems)

  const newDomainsRow: any = { Domain: '', Network: '', CoreVersion: '', Status: '' }
  const isDomainsRowEmpty = (row: { Domain: string, Network: string, CoreVersion: string, Status: string }) => row?.Domain === '' && row?.Network === '' && row?.CoreVersion === '' && row?.Status === '';

  const newWhiteListedRoutesRow: any = { Name: '', Value: '' }
  const isWhiteListedRoutesRowEmpty = (row: { Name: string, Value: string }) => row?.Name === '' && row?.Value === '';

  const newBlackListedNPsRow: any = { NPId: '', Type: '' }
  const isBlackListedNPsRowEmpty = (row: { NPId: string, Type: string }) => row?.NPId === '' && row?.Type === '';

  const newIncludedCitiesRow: any = { Name: '', Value: '', State: '' }
  const isIncludedCitiesRowEmpty = (row: { Name: string, Value: string, State: string }) => row?.Name === '' && row?.Value === '' && row?.State === '';

  const newExcludedCitiesRow: any = { Name: '', Value: '', State: '' }
  const isExcludedCitiesRowEmpty = (row: { Name: string, Value: string, State: string }) => row?.Name === '' && row?.Value === '' && row?.State === '';

  const newMaskedRow: any = { Keyword: '' }
  const isMaskedRowEmpty = (row: { Keyword: string }) => row?.Keyword === '';

console.log('channelsList', channelsList)

  const defaultValue = {
    "Id": 0,
    "GatewayId": 0,
    "UniqueId": "",
    "NpUniqueId": "sring",
    "Status": "",
    "GatewayOptionId": 0,
    "Settings": {
      "Gateway": "",
      "Registry": "",
      "BapId": "",
      "BapUri": "",
      "BppId": "sting",
      "BppUri": "",
      "Domain": "",
      "Port": "",
      "CoreVersion": "",
      "TenantId": 0,
      "Requester": "",
      "StoreId": "",
      "ChannelId": "",
      "ChannelName": "",
      "EmailDomain": "",
      "DefaultUserEmail": "",
      "DefaultUserPhone": "",
      "InternalAccountId": "",
      "SecretKey": "",
      "OndcToken": "strin"
    },
    "Domains": [
    ],
    "Debugger": {
      "IsEnabled": false,
      "Level": "info",
      "Collection": ""
    },
    "WhitelistedRoutes": [

    ],
    "BlacklistedNPs": [

    ],
    "IncludedCitiesForCatalog": [

    ],
    "ExcludedCitiesForCatalog": [

    ],
    "IncludedPincodes": [
    ],
    "ExcludedPincodes": [
    ],
    "MaskedKeywords": [

    ],
    "MongoDB": {
      "ConnectionString": "",
      "DbName": ""
    },
    "Redis": {
      "Host": "",
      "Port": "",
      "UserName": "",
      "Pwd": "",
      "Database": ""
    },
    "Logistics": {
      "Gateway": "",
      "Registry": "",
      "BapId": "",
      "BapUri": "",
      "BppId": "",
      "BppUri": "",
      "Domain": "",
      "Port": "",
      "CoreVersion": ""
    },
    "Polling": {
      "Interval": 100,
      "Duration": 3000
    }
  }

  const [
    selectedGateway,
    setSelectedGateway
  ] = useState<any>({})
  const tenantIdFromGateway = selectedGateway?.TenantId || tenantId;
  const fetchGatewayById = () => {
    dispatch(gatewayRegistries.query({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateway-registries/fetch-detail`, entity: 'gatewayRegistries', jsonData: {
        Context: {},
        Records: [
          {
            "GatewayRegistryId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGateway({ ...selectedGateway, [field]: event });
  }

  const handleFormChange = (event: any, field: string, data: any) => {
    const fields = field.split('.');
    setSelectedGateway((prevState: any) => ({
      ...prevState,
      [fields[0]]: {
        ...prevState[fields[0]],
        [fields[1]]: event // Updating the inner field with event value
      }
    }));
  };

  const listDBNDomains = async () => {
    await dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'list' }))
    await dispatch(tenantOpenNetworkDomains.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch`,
      entity: 'tenantOpenNetworkDomains',
      jsonData: {
        // "PageNumber": pageData,
        // "PageSize": pageSize,
        "SortField": "CreatedOnUtc",
        "SortOrder": "desc",
      }
    }))
  }

  const listStores = async () => {
    dispatch(stores.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/stores/list`,
      entity: 'stores',
      jsonData: {
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": tenantId,
            "FieldType": "number"
          }
        ]
      }
    }))
  }

    const listChannels = async () => {
    dispatch(channel.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`,
      entity: 'channel',
      jsonData: {
        
      }
    }))
  }

  useEffect(
    () => {
      listDBNDomains();
      listStores();
listChannels();
      if (parmas?.id > 0) {
        fetchGatewayById()
        setIsLoading(false)
      }
      else {
        setDomains((prevData) => addNewRow(prevData, newDomainsRow, isDomainsRowEmpty));
        setWhitelistedRoutes((prevData) => addNewRow(prevData, newWhiteListedRoutesRow, isWhiteListedRoutesRowEmpty));
        setBlacklistedNPs((prevData) => addNewRow(prevData, newBlackListedNPsRow, isBlackListedNPsRowEmpty));
        setIncludedCitiesForCatalog((prevData) => addNewRow(prevData, newIncludedCitiesRow, isIncludedCitiesRowEmpty));
        setExcludedCitiesForCatalog((prevData) => addNewRow(prevData, newExcludedCitiesRow, isExcludedCitiesRowEmpty));
        setMaskedKeywords((prevData) => addNewRow(prevData, newMaskedRow, isMaskedRowEmpty));
        setIsLoading(false)
      }
    },
    []
  )

  // useEffect(() => {
  //   console.log('queryItems?.result?.items', queryItems?.result?.items)
  // }, [queryItems]);

  useEffect(
    () => {

      if (isQuery) {
        setSelectedGateway(queryItems?.result?.items)
        setDomains(queryItems?.result?.items?.Domains)
        setWhitelistedRoutes(queryItems?.result?.items?.WhitelistedRoutes)
        setBlacklistedNPs(queryItems?.result?.items?.BlacklistedNPs)
        setIncludedCitiesForCatalog(queryItems?.result?.items?.IncludedCitiesForCatalog)
        setExcludedCitiesForCatalog(queryItems?.result?.items?.ExcludedCitiesForCatalog)
        setMaskedKeywords(queryItems?.result?.items?.MaskedKeywords)
        setIsLoading(false)
      }
    },
    [isQuery]
  )

  const handleDeleteBlacklisedNps = (index: number) => {
    blacklistedNPs.splice(index, 1);
    setBlacklistedNPs([...blacklistedNPs]);
  }
  const handleDeleteDomains = (index: number) => {
    domains.splice(index, 1);
    setDomains([...domains]);
  }
  const handleDeleteExcludedCities = (index: number) => {
    excludedCitiesForCatalog.splice(index, 1);
    setExcludedCitiesForCatalog([...excludedCitiesForCatalog]);
  }
  const handleDeleteIncludedCities = (index: number) => {
    includedCitiesForCatalog.splice(index, 1);
    setIncludedCitiesForCatalog([...includedCitiesForCatalog]);
  }
  const handleDeleteMaskedKeywords = (index: number) => {
    maskedKeywords.splice(index, 1);
    setMaskedKeywords([...maskedKeywords]);
  }
  const handleDeleteWhitelistedRoutes = (index: number) => {
    whitelistedRoutes.splice(index, 1);
    setWhitelistedRoutes([...whitelistedRoutes]);
  }

  useEffect(() => {
    setDomains((prevData) => addNewRow(prevData, newDomainsRow, isDomainsRowEmpty));
  }, [domains]);

  useEffect(() => {
    setWhitelistedRoutes((prevData) => addNewRow(prevData, newWhiteListedRoutesRow, isWhiteListedRoutesRowEmpty));
  }, [whitelistedRoutes]);

  useEffect(() => {
    setBlacklistedNPs((prevData) => addNewRow(prevData, newBlackListedNPsRow, isBlackListedNPsRowEmpty));
  }, [blacklistedNPs]);

  useEffect(() => {
    setIncludedCitiesForCatalog((prevData) => addNewRow(prevData, newIncludedCitiesRow, isIncludedCitiesRowEmpty));
  }, [includedCitiesForCatalog]);

  useEffect(() => {
    setExcludedCitiesForCatalog((prevData) => addNewRow(prevData, newExcludedCitiesRow, isExcludedCitiesRowEmpty));
  }, [excludedCitiesForCatalog]);

  useEffect(() => {
    setMaskedKeywords((prevData) => addNewRow(prevData, newMaskedRow, isMaskedRowEmpty));
  }, [maskedKeywords]);


  const handleFormDomainsItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(domains);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setDomains(items);
  }

  const handleFormWhitelistedRoutesItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(whitelistedRoutes);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setWhitelistedRoutes(items);
  }

  const handleFormBlacklistedNPsItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(blacklistedNPs);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setBlacklistedNPs(items);
  }

  const handleFormIncludedCitiesForCatalogItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(includedCitiesForCatalog);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setIncludedCitiesForCatalog(items);
  }

  const handleFormExcludedCitiesForCatalogItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(excludedCitiesForCatalog);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setExcludedCitiesForCatalog(items);
  }

  const handleFormMaskedKeywordsItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(maskedKeywords);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMaskedKeywords(items);
  }

  // function to set default values if the attribute is null or undefined
  // only attributes in the root are checked and not the nested objects

  function mergeWithDefaults<T extends object>(defaults: T, updates: Partial<T>): T {
    const result = {} as T;

    for (const key in defaults) {
      const updateValue = updates[key as keyof T];
      result[key as keyof T] = updateValue === null || updateValue === undefined
        ? defaults[key as keyof T]
        : updateValue;
    }

    return result;
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    whitelistedRoutes.splice(
      whitelistedRoutes.length - 1,
      1
    )
    blacklistedNPs.splice(
      blacklistedNPs.length - 1,
      1
    )
    includedCitiesForCatalog.splice(
      includedCitiesForCatalog.length - 1,
      1
    )
    excludedCitiesForCatalog.splice(
      excludedCitiesForCatalog.length - 1,
      1
    )
    maskedKeywords.splice(
      maskedKeywords.length - 1,
      1
    )
    domains.splice(
      domains.length - 1,
      1
    )
    const updatedGateway = {
      ...selectedGateway,
      TenantId: tenantIdFromGateway,

      Settings: {
        ...selectedGateway?.Settings,
        TenantId: tenantIdFromGateway
      },

      Domains: domains,
      WhitelistedRoutes: whitelistedRoutes,
      BlacklistedNPs: blacklistedNPs,
      IncludedCitiesForCatalog: includedCitiesForCatalog,
      ExcludedCitiesForCatalog: excludedCitiesForCatalog,
      MaskedKeywords: maskedKeywords
    }
    const merged = mergeWithDefaults(defaultValue, updatedGateway);

    if (parmas?.id > 0) {
      await dispatch(gatewayRegistries.resetAction({ actionType: 'update' }))
      await dispatch(gatewayRegistries.update({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateway-registries`, entity: 'gatewayRegistries', jsonData: {
          Context: {},
          Records: [
            {
              ...merged,
              TenantId: tenantIdFromGateway,
              Settings: {
                ...merged.Settings,
                TenantId: tenantIdFromGateway
              },
              Id: selectedGateway.GatewayRegistryId
            }
          ]

        }
      })).then(() => {
        back()
      })
    } else {
      //     await dispatch(gatewayRegistries.resetAction({ actionType: 'create' }))
      //     await dispatch(gatewayRegistries.create({url:`https://edgegateway.digiit.${import.meta.env.VITE_API_URL}/api/v4.0/dbn-cloud/gateway-registries`,entity:'dbass',jsonData:{

      //       Records: [{
      //         updatedGateway
      //       }   
      //       ]
      // }})).then(()=>{
      //   back()
      // })
    }

  }
  const back = () => {
    navigate('/management/dbn-cloud/gateway-registries')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <GatewayRegistryComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedGateway={selectedGateway}
          domainDetails={domainItems?.result?.items}
          networks={NetworkItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          handleFormChange={handleFormChange}
          stores={storeLists?.result?.items}
          handleFormDomainsItemChange={handleFormDomainsItemChange}
          handleFormWhitelistedRoutesItemChange={handleFormWhitelistedRoutesItemChange}
          handleFormBlacklistedNPsItemChange={handleFormBlacklistedNPsItemChange}
          handleFormIncludedCitiesForCatalogItemChange={handleFormIncludedCitiesForCatalogItemChange}
          handleFormExcludedCitiesForCatalogItemChange={handleFormExcludedCitiesForCatalogItemChange}
          handleFormMaskedKeywordsItemChange={handleFormMaskedKeywordsItemChange}
          handleDeleteBlacklisedNps={handleDeleteBlacklisedNps}
          handleDeleteDomains={handleDeleteDomains}
          channelsList={channelsList?.result?.items}
          handleDeleteExcludedCities={handleDeleteExcludedCities}
          handleDeleteIncludedCities={handleDeleteIncludedCities}
          handleDeleteMaskedKeywords={handleDeleteMaskedKeywords}
          handleDeleteWhitelistedRoutes={handleDeleteWhitelistedRoutes}
          domains={domains}
          // channelsList={channelsList?.result?.items}
          whitelistedRoutes={whitelistedRoutes}
          blacklistedNPs={blacklistedNPs}
          includedCitiesForCatalog={includedCitiesForCatalog}
          excludedCitiesForCatalog={excludedCitiesForCatalog}
          maskedKeywords={maskedKeywords}
          gateways={gatewayItems?.result?.items}
        />
      }
    </>
  )
}
export default GatewayRegistry;
